(function () {'use strict';}());

angular.module('app').filter('response', function() {
    return function(listing,assessment,requireResponse,questionID,questionType) {
    	if(!listing) return listing;
        var trace = angular.trace;
    	var results = [];

    	for(var i = 0, count = listing.length; i < count; i++)
    	{
            var item = listing[i];
            if(requireResponse === true && item.userResponse === undefined) continue;
    		if(assessment && listing[i].assessmentID === assessment) results.push(listing[i]);
            else if(questionID && listing[i].questionID === questionID) results.push(listing[i]);
            else if(questionType && listing[i].type === questionType) results.push(listing[i]);
    	}

        if(questionType)
        {
            results.sort(function(a,b){
                if(a.questionID === b.questionID) return a.assessmentID > b.assessmentID ? 1 : -1;
                return a.questionID > b.questionID ? 1 : -1;
            });
        }

    	return results;
    };
});